import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {State} from '@progress/kendo-data-query';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {UserContext} from '../services/user-context';
import {ApiService} from '../services/api';
import {ProfileDialogComponent} from './profile-dialog.component';
import {PasswordDialogComponent} from './password-dialog.component';
import {
  DragEndEvent,
  DragEvent,
  DragStartEvent, EventClickEvent, SchedulerComponent,
  SchedulerEvent,
  SlotClickEvent
} from '@progress/kendo-angular-scheduler';
import * as moment from 'moment-timezone';
import * as uuidv4 from 'uuid/v4';
import {IntlService} from '@progress/kendo-angular-intl';
import '@progress/kendo-date-math/tz/America/New_York';
import {BehaviorSubject, Subject} from 'rxjs';
import {AvailabilityDialogComponent} from './availability-dialog.component';
import {HttpParams} from '@angular/common/http';
import {Util} from '../services/util';
@Component({
  selector: 'app-connect-result',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'connect-result.template.html',
  styleUrls: [
    './connect-result.style.scss'
  ]
})
export class ConnectResultComponent implements OnInit {
  success = false;
  failed = false;
  user:any;

  constructor(private route: ActivatedRoute,
              public util: Util,
              private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer,
              private changeDetectRef: ChangeDetectorRef,
              private userContext: UserContext,
              private snackBar: MatSnackBar,
              private intlService: IntlService,
              private api: ApiService) {

    this.success = this.util.getFullRoutePathByActivatedRoute('', route).includes("success");
    this.failed = this.util.getFullRoutePathByActivatedRoute('', route).includes("failure");
  }

  public ngOnInit(): void {
      this.refresh();
  }

  public refresh(): void {
      this.api.get<any>(`/user/${this.userContext.user.reference}`)
        .subscribe(result => {
          this.user = result;
        }, (error) => {
          console.log('Found error ' + JSON.stringify(error));
        });
  }

  public verifyConnectAccount(): void {
    this.api.get<any>(`/user/${this.userContext.user.reference}/connect/verify`)
      .subscribe(result => {
        console.log("Received connect: " + JSON.stringify(result));
        if( result.url ) {
          window.location = result.url;
        }
      });
  }

  public updateConnectAccount(): void {
    this.api.get<any>(`/user/${this.userContext.user.reference}/connect/update`)
      .subscribe(result => {
        console.log("Received connect: " + JSON.stringify(result));
        if( result.url ) {
          window.location = result.url;
        }
      });
  }

}
